// route redux reducers
const initialState = {
  toPage: null,
  action: null,
  tool: "S2R",
};

const routeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "route/toPage":
      return {
        ...state,
        toPage: action.page,
      };

    // defines an action to do after a route change
    case "route/actionAfterPage":
      return {
        ...state,
        action: action.action,
      };

    case "route/toolChange":
      return {
        ...state,
        tool: action.tool,
      };

    default:
      return state;
  }
};
export default routeReducer;
